/* ••[1]••••••••••••••••••••••••• eventCarouselVm.ts •••••••••••••••••••••••••••••• */

import { CustomElement } from "../../core/CustomElement";
import {
  EventCarouselItem,
  validatedEventCarouselItems,
} from "../../core/types/EventCarousel";

import ko from "knockout";

export default class EventCarouselVm {
  $customElement: CustomElement;
  items: KnockoutObservableArray<EventCarouselItem>;

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.items = ko.observableArray([]);
  }

  hasLink(item: EventCarouselItem): boolean {
    return Object.prototype.hasOwnProperty.call(item, "link");
  }

  hasNoLink(item: EventCarouselItem): boolean {
    return !Object.prototype.hasOwnProperty.call(item, "link");
  }

  private display(): boolean {
    return !!validatedEventCarouselItems(this.items()).length;
  }
}
